import { ChangeEventHandler, forwardRef, HTMLInputTypeAttribute, InputHTMLAttributes, RefAttributes } from "react";
import {
  roundedClassName,
  borderClassName,
  inputClassName,
  inputColorClassName,
  sizeClassName,
  getFocusOutline,
} from "./commonClassNames";
import { BorderProps, InputColorProps, InputTextSizeProp, InputCustomClassProp } from "./commonProps";

export type InputTextProps = Omit<InputHTMLAttributes<HTMLInputElement>, "className" | "onChange" | "type"> &
  RefAttributes<HTMLInputElement> &
  BorderProps &
  InputColorProps &
  InputTextSizeProp & {
    setValue?: (value: string) => void;
    type?: Extract<HTMLInputTypeAttribute, "text" | "email" | "password" | "number"> | undefined;
    small?: boolean;
  } & InputCustomClassProp;

export const InputText: React.FC<InputTextProps> = forwardRef(
  ({ border, grouped, neutral, setValue, textSize, transparent, type = "text", className, small, ...props }, ref) => {
    const combinedClassName = [
      "font-normal",
      small === true ? "p-1 h-8" : "",
      roundedClassName({ grouped }),
      borderClassName({ border }),
      inputClassName(),
      inputColorClassName({ transparent, neutral }),
      sizeClassName({ size: textSize }),
      getFocusOutline({ border }),
      className,
    ].join(" ");

    const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
      const value = event.target.value;
      setValue?.(value);
    };

    return <input type={type} className={combinedClassName} onChange={onChange} {...props} ref={ref} />;
  },
);
